// extracted by mini-css-extract-plugin
export default {"tabContent":"PropertyList__tabContent___uHb7c"};